import Vue from 'vue';
import Vuex from 'vuex';
import home from './modules/home';
import chat from './modules/chat';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    home,
    chat
  },
  // strict: debug,  // 暂时关闭严格模式  操作人:yuanchongen
  plugins: [],
  state: {
    unread: {}
  },
  mutations: {
    updateUnread: function (state, obj) {
      state.unread = Object.assign({}, state.unread, obj);
    }
  },
  actions: {
    updateUnread: function (context, obj) {
      context.commit('updateUnread', obj);
    }
  },
  getters: {
    unread: state => {
      var total = 0;
      for (var key in state.unread) {
        total += state.unread[key];
      }
      return total;
    }
  }
});
